import React from 'react';
import { Search, FileText, ShieldCheck, RefreshCw, BarChart3, Lock } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { CTASection } from '../components/CTASection';
interface LeistungenPageProps {
  onNavigate: (page: string) => void;
}
export function LeistungenPage({
  onNavigate
}: LeistungenPageProps) {
  return <div className="min-h-screen bg-white" data-id="element-509">
      {/* Header */}
      <div className="bg-slate-50 py-20 lg:py-28 border-b border-slate-200 relative overflow-hidden" data-id="element-510">
        <div className="absolute top-0 right-0 -z-10 h-96 w-96 rounded-full bg-blue-100 blur-3xl opacity-50 translate-x-1/3 -translate-y-1/4" data-id="element-511"></div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-512">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-6" data-id="element-513">
            Unsere Premium-Leistungen
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-514">
            Ganzheitliche Lösungen für Ihre finanzielle Gesundheit. Von der
            KI-Analyse bis zur persönlichen Schadensregulierung – alles aus
            einer Hand.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-20 space-y-24" data-id="element-515">
        {/* Service 1 */}
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-516">
          <div className="order-2 md:order-1" data-id="element-517">
            <div className="inline-flex items-center justify-center p-4 bg-blue-100 text-blue-600 rounded-2xl mb-6 shadow-sm" data-id="element-518">
              <BarChart3 className="h-8 w-8" data-id="element-519" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900" data-id="element-520">
              Intelligente Bedarfsanalyse
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-521">
              Unser SmartProtect-Algorithmus prüft Ihre aktuelle Lebenssituation
              und identifiziert Risiken präzise. Wir zeigen Ihnen transparent
              auf, welche Versicherungen essentiell sind und wo Sie
              überversichert sind.
            </p>
            <ul className="space-y-4 mb-10" data-id="element-522">
              <li className="flex items-center gap-3" data-id="element-523">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-524">
                  <ShieldCheck className="h-4 w-4 text-green-600" data-id="element-525" />
                </div>{' '}
                <span className="font-medium text-slate-700" data-id="element-526">
                  Individueller 360° Risikocheck
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-527">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-528">
                  <ShieldCheck className="h-4 w-4 text-green-600" data-id="element-529" />
                </div>{' '}
                <span className="font-medium text-slate-700" data-id="element-530">
                  Vermeidung von Doppelversicherungen
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-531">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-532">
                  <ShieldCheck className="h-4 w-4 text-green-600" data-id="element-533" />
                </div>{' '}
                <span className="font-medium text-slate-700" data-id="element-534">
                  Objektive, datenbasierte Empfehlungen
                </span>
              </li>
            </ul>
            <Button onClick={() => onNavigate('rechner')} variant="premium" size="lg" data-id="element-535">
              Jetzt Analyse starten
            </Button>
          </div>
          <div className="order-1 md:order-2 relative" data-id="element-536">
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-600 to-indigo-600 rounded-3xl blur-2xl opacity-20" data-id="element-537"></div>
            <div className="bg-white p-8 rounded-3xl shadow-2xl border border-slate-100 h-96 flex items-center justify-center relative z-10" data-id="element-538">
              <span className="text-slate-400 font-medium text-lg" data-id="element-539">
                [Grafik: Analyse Dashboard]
              </span>
            </div>
          </div>
        </div>

        {/* Service 2 */}
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-540">
          <div className="relative" data-id="element-541">
            <div className="absolute inset-0 bg-gradient-to-bl from-amber-400 to-orange-500 rounded-3xl blur-2xl opacity-10" data-id="element-542"></div>
            <div className="bg-white p-8 rounded-3xl shadow-2xl border border-slate-100 h-96 flex items-center justify-center relative z-10" data-id="element-543">
              <span className="text-slate-400 font-medium text-lg" data-id="element-544">
                [Grafik: Vergleichsrechner]
              </span>
            </div>
          </div>
          <div data-id="element-545">
            <div className="inline-flex items-center justify-center p-4 bg-amber-100 text-amber-600 rounded-2xl mb-6 shadow-sm" data-id="element-546">
              <RefreshCw className="h-8 w-8" data-id="element-547" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900" data-id="element-548">
              Unabhängiger Premium-Vergleich
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-549">
              Wir vergleichen Tarife von über 300 geprüften Versicherern. Dabei
              achten wir nicht nur auf den Preis, sondern vor allem auf das
              Kleingedruckte und die Leistung im Schadensfall.
            </p>
            <ul className="space-y-4 mb-10" data-id="element-550">
              <li className="flex items-center gap-3" data-id="element-551">
                <div className="bg-amber-100 p-1 rounded-full" data-id="element-552">
                  <ShieldCheck className="h-4 w-4 text-amber-600" data-id="element-553" />
                </div>{' '}
                <span className="font-medium text-slate-700" data-id="element-554">
                  Echte Best-Preis-Garantie
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-555">
                <div className="bg-amber-100 p-1 rounded-full" data-id="element-556">
                  <ShieldCheck className="h-4 w-4 text-amber-600" data-id="element-557" />
                </div>{' '}
                <span className="font-medium text-slate-700" data-id="element-558">
                  Transparente Leistungsübersicht
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-559">
                <div className="bg-amber-100 p-1 rounded-full" data-id="element-560">
                  <ShieldCheck className="h-4 w-4 text-amber-600" data-id="element-561" />
                </div>{' '}
                <span className="font-medium text-slate-700" data-id="element-562">
                  Automatischer Wechsel-Service
                </span>
              </li>
            </ul>
            <Button variant="outline" size="lg" onClick={() => onNavigate('rechner')} data-id="element-563">
              Zu den Vergleichsrechnern
            </Button>
          </div>
        </div>

        {/* Service 3 */}
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-564">
          <div className="order-2 md:order-1" data-id="element-565">
            <div className="inline-flex items-center justify-center p-4 bg-indigo-100 text-indigo-600 rounded-2xl mb-6 shadow-sm" data-id="element-566">
              <Lock className="h-8 w-8" data-id="element-567" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900" data-id="element-568">
              Digitaler Safe & Vertragsordner
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-569">
              Schluss mit Papierkram. In der SmartProtect24 App haben Sie alle
              Policen griffbereit und sicher verschlüsselt. Wir digitalisieren
              Ihre bestehenden Verträge automatisch.
            </p>
            <ul className="space-y-4 mb-10" data-id="element-570">
              <li className="flex items-center gap-3" data-id="element-571">
                <div className="bg-indigo-100 p-1 rounded-full" data-id="element-572">
                  <ShieldCheck className="h-4 w-4 text-indigo-600" data-id="element-573" />
                </div>{' '}
                <span className="font-medium text-slate-700" data-id="element-574">
                  Bank-Level Sicherheit (AES-256)
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-575">
                <div className="bg-indigo-100 p-1 rounded-full" data-id="element-576">
                  <ShieldCheck className="h-4 w-4 text-indigo-600" data-id="element-577" />
                </div>{' '}
                <span className="font-medium text-slate-700" data-id="element-578">
                  Automatische Kündigungserinnerung
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-579">
                <div className="bg-indigo-100 p-1 rounded-full" data-id="element-580">
                  <ShieldCheck className="h-4 w-4 text-indigo-600" data-id="element-581" />
                </div>{' '}
                <span className="font-medium text-slate-700" data-id="element-582">
                  1-Klick Schadensmeldung
                </span>
              </li>
            </ul>
            <Button onClick={() => onNavigate('app')} variant="premium" size="lg" data-id="element-583">
              App entdecken
            </Button>
          </div>
          <div className="order-1 md:order-2 relative" data-id="element-584">
            <div className="absolute inset-0 bg-gradient-to-tl from-indigo-600 to-purple-600 rounded-3xl blur-2xl opacity-20" data-id="element-585"></div>
            <div className="bg-white p-8 rounded-3xl shadow-2xl border border-slate-100 h-96 flex items-center justify-center relative z-10" data-id="element-586">
              <span className="text-slate-400 font-medium text-lg" data-id="element-587">
                [Grafik: App Mockup]
              </span>
            </div>
          </div>
        </div>
      </div>

      <CTASection title="Überzeugt von SmartProtect24?" description="Starten Sie jetzt mit der Optimierung Ihrer Finanzen auf Premium-Niveau." primaryCtaText="Kostenlos registrieren" onPrimaryClick={() => onNavigate('app')} data-id="element-588" />
    </div>;
}